import request from "@/utils/request";
import Qs from "qs";
// 房屋租赁
// 房屋租赁轮播图
export function banner_list(data) {
  return request({
    url: "/hire/banner_list",
    method: "post",
    data: Qs.stringify(data),
  });
}
// 添加房屋租赁轮播图
export function add_banner(data) {
  return request({
    url: "/hire/add_banner",
    method: "post",
    data: Qs.stringify(data),
  });
}
// 编辑房屋租赁轮播图
export function edit_banner(data) {
  return request({
    url: "/hire/edit_banner",
    method: "post",
    data: Qs.stringify(data),
  });
}
// 删除房屋租赁轮播图
export function banner_del(data) {
  return request({
    url: "/hire/banner_del",
    method: "post",
    data: Qs.stringify(data),
  });
}
// 删除房屋租赁轮播图
export function banner_info(data) {
  return request({
    url: "/hire/banner_info",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 房屋类型
// 房屋类型添加
export function add_type(data) {
  return request({
    url: "/hire/add_type",
    method: "post",
    data: Qs.stringify(data),
  });
}
//编辑房屋类型
export function edit_type(data) {
  return request({
    url: "/hire/edit_type",
    method: "post",
    data: Qs.stringify(data),
  });
}
// 房屋类型列表
export function type_list(data) {
  return request({
    url: "/hire/type_list",
    method: "post",
    data: Qs.stringify(data),
  });
}
// 房屋类型详情
export function type_info(data) {
  return request({
    url: "/hire/type_info",
    method: "post",
    data: Qs.stringify(data),
  });
}
// 删除房屋类型
export function type_del(data) {
  return request({
    url: "/hire/type_del",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 租赁房屋
// 添加房屋租赁
export function add_house(data) {
  return request({
    url: "/hire/add_house",
    method: "post",
    data: Qs.stringify(data),
  });
}
// 编辑房屋租赁
export function edit_house(data) {
  return request({
    url: "/hire/edit_house",
    method: "post",
    data: Qs.stringify(data),
  });
}
// 房屋租赁列表
export function house_list(data) {
  return request({
    url: "/hire/house_list",
    method: "post",
    data: Qs.stringify(data),
  });
}
// 删除房屋租赁
export function house_del(data) {
  return request({
    url: "/hire/house_del",
    method: "post",
    data: Qs.stringify(data),
  });
}
// 房屋租赁详情
export function house_info(data) {
  return request({
    url: "/hire/house_info",
    method: "post",
    data: Qs.stringify(data),
  });
}
// 意向用户列表
export function intention_user(data) {
  return request({
    url: "/hire/intention_user",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 房屋租赁列表
export function hire_house_list(data) {
  return request({
    url: "/common/hire_house_list",
    method: "post",
    data: Qs.stringify(data),
  });
}
